import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PROF_LABEL } from "@/components/cafe/JobBoard";
import { REGIONS } from "@/components/cafe/JobAlert";

const INPUT = "h-9 w-full rounded-lg border border-slate-700 bg-slate-950 px-2 text-xs text-white placeholder:text-slate-500";
const TEXT = [["title", "Titolo"], ["employer", "Struttura"], ["province", "Provincia"], ["city", "Città"], ["contract_type", "Contratto"], ["salary", "Retribuzione"]];
const FIELDS = ["title", "profession", "employer", "region", "province", "city", "contract_type", "salary", "description", "expires_at"];

function Field({ label, children }) {
  return <label className="space-y-1 text-[10px] uppercase tracking-wider text-slate-400"><span>{label}</span>{children}</label>;
}

export function OfferEditDialog({ o, onClose, onSaved }) {
  const [f, setF] = useState(() => Object.fromEntries(FIELDS.map((k) => [k, o[k] || ""])));
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/superadmin/jobs/${o.id}`, { fields: f });
      toast.success("Annuncio modificato");
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto border-slate-700 bg-slate-900 text-white sm:max-w-2xl" data-testid="jobs-edit-dialog">
        <DialogHeader><DialogTitle>Modifica annuncio</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          {TEXT.map(([k, l]) => <Field key={k} label={l}><input data-testid={`jobs-edit-${k}`} value={f[k]} onChange={set(k)} className={INPUT} /></Field>)}
          <Field label="Professione"><select data-testid="jobs-edit-profession" value={f.profession} onChange={set("profession")} className={INPUT}>{Object.entries(PROF_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
          <Field label="Regione"><select data-testid="jobs-edit-region" value={f.region} onChange={set("region")} className={INPUT}><option value="">Non indicata</option>{REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}</select></Field>
          <Field label="Scadenza"><input data-testid="jobs-edit-expires" type="date" value={f.expires_at.slice(0, 10)} onChange={(e) => setF({ ...f, expires_at: e.target.value ? `${e.target.value}T23:59:00+00:00` : "" })} className={INPUT} /></Field>
          <div className="sm:col-span-2"><Field label="Descrizione"><textarea data-testid="jobs-edit-description" rows={4} maxLength={600} value={f.description} onChange={set("description")} className={`${INPUT} h-auto py-2`} /></Field></div>
        </div>
        <p className="text-[10px] text-slate-500">Il link originale ({o.source}) non si modifica: garantisce che l'annuncio resti verificabile.</p>
        <div className="flex justify-end gap-2">
          <button data-testid="jobs-edit-cancel" onClick={onClose} className="rounded-xl border border-slate-600 px-4 py-2 text-xs text-slate-200">Annulla</button>
          <button data-testid="jobs-edit-save" disabled={busy} onClick={save} className="flex items-center gap-1.5 rounded-xl border border-[#00F0FF]/40 px-4 py-2 text-xs font-bold text-[#00F0FF]">{busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Salva modifiche</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
